import styled from 'styled-components';
import Parent from '../Base/style';

const Container = styled(Parent.Container)``;

const SuccessIconComponent = { Container };
export default SuccessIconComponent;
